module.exports = __webpack_public_path__ + "media/images/service/s_4-c8be20d0cf6b7930a14cca97840a9b3c.png";